import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import apis from "@/api";
export default {
  components: {},
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const router = useRouter();
    const data = reactive({
      count1: 0,
      count2: 0,
      count3: 0,
      activities: []
    });
    const showAdd = type => {
      if (type === 'src') {
        router.push("/my-needs/add");
      } else if (type === 'sms') {
        router.push("/my-needs/addSms");
      } else if (type === 'finished') {
        router.push("/my-needs/addFinished");
      } else if (type === 'printed') {
        router.push("/my-needs/addPrinted");
      }
    };
    const countOfDemand = () => {
      apis.countOfDemand().then(res => {
        if (res.success) {
          data.count1 = res.data.count1;
          data.count2 = res.data.count2;
          data.count3 = res.data.count3;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const myHisLog = () => {
      apis.myHisLog().then(res => {
        if (res.success) {
          data.activities = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const refresh = () => {
      // countOfDemand();
      myHisLog();
    };
    return {
      ...toRefs(data),
      showAdd,
      refresh
    };
  }
};